import Chart from "react-apexcharts";

function DataChart(props) {
  const state = {
    options: {
      colors: ["#772CF3"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.8,
          opacityTo: 0.9,
          stops: [0, 100, 100],
        },
      },
      chart: {
        toolbar: {
          show: false,
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
          },
        },
      },
      xaxis: {
        categories: props.stats.gainMonths,
      },
      dataLabels: {
        enabled: false,
        style: {
          colors: ["#772CF3"],
        },
      },
      strocke: {
        curve: "smooth",
      },
    },
    series: [
      {
        name: "Chiffre d'affaires",
        data: props.stats.gains,
      },
    ],
  };

  return (
    <>
      <Chart
        options={state.options}
        series={state.series}
        type="area"
        width="100%"
        height="300"
      />
    </>
  );
}

export default DataChart;
